/**
 * TanStack Query hooks for `recurring-commission-saas-model`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	recurringCommissionSaasModelQueryKeys,
	type CreateRecurringCommissionSaasModelBody,
	type ListRecurringCommissionSaasModelResponse,
	type RecurringCommissionSaasModelRow,
} from "./api";

export function useRecurringCommissionSaasModelList(): UseQueryResult<ListRecurringCommissionSaasModelResponse, Error> {
	return useQuery({
		queryKey: recurringCommissionSaasModelQueryKeys.list(),
		queryFn: list,
	});
}

export function useRecurringCommissionSaasModelCreate(): UseMutationResult<RecurringCommissionSaasModelRow, Error, CreateRecurringCommissionSaasModelBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: recurringCommissionSaasModelQueryKeys.all });
		},
	});
}

export function useRecurringCommissionSaasModelDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: recurringCommissionSaasModelQueryKeys.all });
		},
	});
}
